<template>
  <div>
    <v-toolbar-title v-if="$vuetify.theme.dark == false" class="text-uppercase grey--text">
      <v-tooltip right color="primary">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" @click="setTheme(true)" v-on="on">
            <v-icon>
              mdi-white-balance-sunny
            </v-icon>
          </v-btn>
        </template>
        <span>
          Passer en thème sombre
        </span>
      </v-tooltip>
    </v-toolbar-title>

    <v-toolbar-title v-if="$vuetify.theme.dark == true" class="text-uppercase grey--text">
      <v-tooltip right color="primary">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" @click="setTheme(false)" v-on="on">
            <v-icon>
              mdi-weather-night
            </v-icon>
          </v-btn>
        </template>
        <span>
          Passer en thème clair
        </span>
      </v-tooltip>
    </v-toolbar-title>
  </div>
</template>

<script>
import { useUserStore } from "@/stores/user";

export default {
  name: "ComponentDarkModeSwitch",
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  methods: {
    setTheme(dark) {
      const theme = dark ? "dark" : "light";
      this.$vuetify.theme.dark = dark;

      if (this.userStore.user)
        this.userStore.updateTheme(theme);
    },
  },
};
</script>
